import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppState } from './app.service';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from "./footer/footer.component";
import { CommonModule } from '@angular/common';
import { SessionTimeoutService } from '../services/session-timeout.service';
import { UserService } from '../services/user.service';
import { ProfileService } from '../services/profile.service';
import { IUser } from '../interfaces/user';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, FooterComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  public isMaintenance = false;
  constructor(
    public appState: AppState,
    private sessionTimeout: SessionTimeoutService,
    private userService: UserService,
    private profileService: ProfileService
  ) {}

  ngOnInit(): void {
    if (sessionStorage.getItem('auth_token')) {
      // this.sessionTimeout.start();
      localStorage.removeItem('userProfile')
      this.hydrateUserProfileFromApi();
    }
  }

  private hydrateUserProfileFromApi(): void {
    if (this.userService.snapshot) return;

    this.profileService.getUserProfile()
      .then((profile) => {
        const { firstName, lastName, email, customerId, preferredLanguage } = profile || {};
        const user: IUser = {
          firstName: firstName || '',
          lastName: lastName || '',
          email,
          customerId,
          preferredLanguage
        };
        this.userService.setUser(user);
      })
      .catch(() => {
        // Keep user state as-is; auth guard/session timeout will handle invalid sessions.
      });
  }
}
